import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useImperativeHandle } from 'react';
import { useMarker } from './useMarker';
export * from './useMarker';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    marker,
    setType
  } = useMarker(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => props.type && setType(props.type), [props.type]);
  useImperativeHandle(ref, () => _extends({}, props, {
    marker
  }));
  return null;
});